module.exports = __webpack_public_path__ + "img/elpais.ef5144b7.svg";